import { CmsApplianceDetailsPage } from '../../appliance-details-page/cms/cms-appliance-details-page.interface';

export interface ApplianceDetailsFormConfig {
  cmsData: CmsApplianceDetailsPage;
}
